import { motion } from "framer-motion";
import { Shield, ChevronDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1680992046615-065f58bcb4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxkYXJrJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3NzUyNDUxODN8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#050508]/85" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#00E5FF]/5 via-transparent to-[#050508]" />
      </div>

      {/* Grid overlay */}
      <div className="absolute inset-0 grid-bg opacity-40" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-[#1A2332] bg-[#0D0F14]/80 px-4 py-2 mb-8">
            <Shield size={14} className="text-[#00E5FF]" />
            <span className="text-xs font-mono text-[#94A3B8] uppercase tracking-[0.2em]">
              Enterprise Agent Security
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-white leading-[0.95] mb-6"
          >
            Deterministic Security
            <br />
            <span className="text-[#00E5FF] text-glow">
              for Enterprise AI Agents
            </span>
          </h1>

          {/* Subhead */}
          <p
            data-testid="hero-subhead"
            className="text-base sm:text-lg text-[#94A3B8] max-w-2xl mx-auto leading-relaxed mb-10"
          >
            Secure your LLM workflows with ML-enabled ACL control planes. 
            We stop rogue agents at the read-to-mutation boundary — 
            not at the perimeter.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              data-testid="hero-book-demo-btn"
              className="bg-[#00E5FF] text-[#050508] font-bold px-8 py-4 hover:bg-[#33EAFF] transition-colors glow-cyan hover:glow-cyan-strong text-sm uppercase tracking-wider"
            >
              Book a Demo
            </a>
            <a
              href="#solution"
              data-testid="hero-view-architecture-btn"
              className="border border-[#1A2332] text-white font-bold px-8 py-4 hover:border-[#00E5FF] transition-all text-sm uppercase tracking-wider"
            >
              View Architecture
            </a>
          </div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <ChevronDown size={24} className="text-[#94A3B8]" />
        </motion.div>
      </div>
    </section>
  );
}
